export enum ManifestItemType {
  STANDARD_DONATION = 'StandardDonation',
  STOP = 'Stop',
  ADDRESS = 'Address',
}
